import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { routing } from './app-routing';
import { AppComponent } from './app.component';
import { createTranslateLoader } from './shared/http-loader-factory';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './shared/services/auth.service';
import { SearchService } from './shared/services/search.service';
import { ToastrModule } from 'ngx-toastr';
import { ApiService } from './shared/services/helpers/api.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TermsModule } from './shared/modal/terms/terms.module';
import { PrivacyModule } from './shared/modal/privacy/privacy.module';
import { IntroductionVideoModule } from './shared/modal/introduction-video/introduction-video.module';
import { InstructorForCompanyModule } from './shared/modal/instructor-for-company/instructor-for-company.module';
import { ParticipantFormModule } from './shared/modal/participant-form/participant-form.module';
import { CompanyService } from './shared/services/company.service';
import { SessionService } from './shared/services/session.service';
import { AppService } from './shared/services/app.service';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ReferencesModule } from './shared/modal/references/references.module';
import { PipesModule } from './shared/pipes/pipes.module';
import { ScenarioItemModule } from './shared/modal/scenario-item/scenario-item.module';
import { SocketService } from './shared/services/socket.service';
import { DialogModule } from './shared/modal/dialog/dialog.module';
import { ImagePreviewModule } from './shared/modal/image-preview/image-preview.module';

import { MessagesService } from './shared/services/messages.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { getErrorHandler } from './shared/services/helpers/error-handler';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AngularSvgIconModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    RouterModule,
    ImagePreviewModule,
    routing,
    BrowserAnimationsModule,
    HttpClientModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    TermsModule,
    PrivacyModule,
    IntroductionVideoModule,
    DialogModule,
    InstructorForCompanyModule,
    ParticipantFormModule,
    ReferencesModule,
    ScenarioItemModule,
    PipesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot(),
  ],
  exports: [TranslateModule],
  providers: [
    AuthService,
    ApiService,
    CompanyService,
    SearchService,
    SessionService,
    AppService,
    SocketService,
    MessagesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useFactory: getErrorHandler,
    },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
